import React from 'react';
import moment from 'moment-timezone';
import { List ,ListItem , Grid , DialogContentText } from '@material-ui/core';

const AuditTrail = (props: any) => {

    let { row } = props
    
    const fields = [
        {   name: 'createdAt', 
            label: 'Date Created',
            render: <>{moment(row?.createdAt).tz('America/Los_Angeles').format('MM/DD/YYYY hh:mm A')}</>
        
        },
        {
            name: 'updatedAt',
            label: 'Created By',
            render: <> No Date </>
        },
        {   
            name: 'updatedAt', 
            label: 'Date Last Modified' ,
            render: <>{moment(row?.updatedAt).tz('America/Los_Angeles').format('MM/DD/YYYY hh:mm A')}</>
        },
        {   
            name: '', 
            label: 'Updated By' , 
            render:<> No Data </> },
        {   
            name: 'match_activity_timestamp', 
            label: 'Date Signing Agent Assigned' , 
            render:<>{row?.match_activity_timestamp ? moment(row?.match_activity_timestamp).tz('America/Los_Angeles').format('MM/DD/YYYY hh:mm A') : 'No Data'}</> },
        { 
            name: '', 
            label: 'Date Closed' , 
            render:<> No Data </> 
        }
      ]

  return (
    <>
        <List>
            {fields.map(f => (
            <ListItem>
                <Grid container>
                <Grid item xs={6}>
                    <DialogContentText>
                    <b>{f?.label}</b>
                    </DialogContentText>
                </Grid><Grid item xs={6}>
                    <DialogContentText>
                    {f?.render || row?.[f?.name]}
                    </DialogContentText>
                </Grid>
                </Grid>
            </ListItem>))}
      </List>
    </>
  );
}

export { AuditTrail };
